export const BOX_GET = 'BOX_GET';
export const BOX_ACTIVE_SET = 'BOX_ACTIVE_SET';
export const BOX_ACTIVE_UPDATE_KIND = 'BOX_ACTIVE_UPDATE_KIND';
export const BOX_ACTIVE_UPDATE_FORMAT = 'BOX_ACTIVE_UPDATE_FORMAT';
export const BOX_ACTIVE_UPDATE_THEME_SLUG = 'BOX_ACTIVE_UPDATE_THEME_SLUG';
export const BOX_ACTIVE_UPDATE_THEME_FONTS = 'BOX_ACTIVE_UPDATE_THEME_FONTS';
export const BOX_ACTIVE_UPDATE_NAME = 'BOX_ACTIVE_UPDATE_NAME';
export const BOX_LIST_SET = 'BOX_LIST_SET';
export const BOX_LIST_REMOVE = 'BOX_LIST_REMOVE';
export const BOX_LIST_UPDATE_NAME = 'BOX_LIST_UPDATE_NAME';
export const BOX_ACTIVE_RESET = 'BOX_ACTIVE_RESET';
export const BOX_SET_CONFIG = 'BOX_SET_CONFIG';
export const BOX_UPDATE_CONFIG = 'BOX_UPDATE_CONFIG';
export const BOX_UPDATE_CONFIG_STYLE = 'BOX_UPDATE_CONFIG_STYLE';
export const BOX_UPDATE_CONTENT_BODY = 'BOX_UPDATE_CONTENT_BODY';
export const KLICKPAGES_HEADER_ACTIVE = 'KLICKPAGES_HEADER_ACTIVE';



/** WEBPACK FOOTER **
 ** ./src/store/modules/box/types.js
 **/